import React from 'react'
import AppFooter from '../../components/AppFooter/AppFooter';
import AppLogin from '../../components/AppLogin/AppLogin';

export default function Register() {
  return (
    <div>
      <AppLogin />
      <AppFooter />
    </div>
  );
}
